var render = function (_h,_vm) {var _c=_vm._c;return (_vm.props.filter.colorUrl)?_c('img',{staticClass:"ebx-filter__color-circle",attrs:{"src":("" + (_vm.props.filter.colorUrl))}}):_c('span',{staticClass:"ebx-filter__title"},[_vm._v(" "+_vm._s(_vm.props.filter.title))])}
var staticRenderFns = []

export { render, staticRenderFns }